var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNovoGrupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-1",
    cx: 16,
    cy: 16,
    rx: 16,
    ry: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(54,216,150)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    mask: "url(#mask-2)",
    xlinkHref: "#ellipse-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M24.00120115 14.71436728l-.00000144 2.5715332-6.7142334-.00000377-.00000377 6.71435547-2.57147217-.00000144.00000377-6.71435547-6.71429443-.00000377.00000144-2.5715332 6.71429444.00000377.00000377-6.71411133 2.57147217.00000144-.00000378 6.71411133 6.7142334.00000377z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNovoGrupo);
export default __webpack_public_path__ + "static/media/add_novo_grupo.864c91079cfc36e01b508acad84a9259.svg";
export { ForwardRef as ReactComponent };